export default function Configure($stateProvider) {
    $stateProvider.state('personnes-perf', {
        parent: 'common',
        url: '/personnes-perf',
        //abstract: true,
        views: {
            common: {
                template: '<ui-view></ui-view>'
            }
        },
        ncyBreadcrumb: {
            // le state étant parent et abstract, on décide de ne pas l'afficher dans le fil d'ariane
            //skip: true
            label: '{{ "LAYOUT.NAVIGATION.PERFORMANCE_PERSONNEL" | translate }}'
        }
    });

    $stateProvider.state('personnes-perf.list', {
        url: '/:genre/list',
        template: '<personnes></personnes>',
        rights: { domain: 'personnel', right: 'read', application: 'performance' },
        params: {
            genre: 'personne'
        },
        ncyBreadcrumb: {
            parent: 'personnes-perf',
            label: '{{ "PERSONNES.BREADCRUMBS.PERSONNES_LIST" | translate}}'
        },
        // on affiche la liste des personnes dans la navigation
        navigation: {
            menu: 'performance_personnel_donnees',
            translate: 'PERSONNES.BREADCRUMBS.PERSONNES_LIST'
        },
        // la liste des personnes fait partie des points d'entrée recherchables dans la navigation
        search: 'PERSONNES.BREADCRUMBS.PERSONNES_LIST'
    });

    $stateProvider.state('personnes-perf.list.detail', {
        url: '/{id}',
        template: '<personne-detail></personne-detail>',
        //rights: {domain: 'personnel', right: 'read'},
        ncyBreadcrumb: {
            parent: 'personnes-perf.list',
            label: '{{ "PERSONNES.BREADCRUMBS.PERSONNE_DETAIL" | translate }}'
        }
    });

    $stateProvider.state('personnes-perf.new', {
        url: '/:genre/new',
        template: '<personnes-form></personnes-form>',
        //rights: {domain: 'personnel', right: 'create'},
        ncyBreadcrumb: {
            // on décide que la liste est le parent des autres states
            // afin d'afficher personnes > ajouter
            parent: 'personnes-perf.list({genre: "personne"})',
            label: '{{ "PERSONNES.BREADCRUMBS.PERSONNE_NEW" | translate}}'
        },
        // l'ajout d'un arret fait partie des points d'entrée recherchables dans l'application
        search: 'PERSONNES.BREADCRUMBS.PERSONNE_NEW'
    });

    $stateProvider.state('personnes-perf.edit', {
        url: '/:genre/{id}/edit',
        template: '<personnes-form></personnes-form>',
        //rights: {domain: 'personnel', right: 'update'},
        ncyBreadcrumb: {
            // on décide que la liste est le parent des autres states
            // afin d'afficher personnes > modifier
            parent: 'personnes-perf.list({genre: "personne"})',
            label: '{{ "PERSONNES.BREADCRUMBS.PERSONNE_EDIT" | translate }}'
        }
    });

    /*$stateProvider.state('personnes.newType', {
        url: '/new-type',
        template: '<type-form></type-form>',
        rights: {domain: 'types', right: 'create'},
        params: {parentState:'personnes.new'},
        ncyBreadcrumb: {
            parent: 'personnes.new({genre: "personne"})',
            label: '{{ "TYPES.BREADCRUMBS.TYPE_NEW" | translate}}'
        }
    });*/
}

Configure.$inject = ['$stateProvider'];
